import type { CommonStylesPalette } from '../types.d';

// this style is in right a panel, out of the feature scope, so use as the global pattern
/* eslint-disable @typescript-eslint/no-unused-vars */
export const keywordToolbarStyle = ({ palette = {} as CommonStylesPalette, iconFontFamily = 'MsAds MDL2 Assets' }) => ({

  '.advanced-keyword-planner-toolbar': {
    '& .btn': {
      marginRight: 12,
    },

    '& .dropdown-menu': {
      '& .grid-submenu-flyout': {
        position: 'relative',

        '& a': {
          paddingRight: 24,
        },

        '& .caret-right': {
          position: 'absolute',
          right: 0,
          marginRight: 8,
        },

        '& .caret-right:before': {
          content: '"\\E76C"',
        },

        '& .adgroups-list': {
          opacity: 1,
          visibility: 'visible',
          left: '100%',
          top: 7,
          display: 'none',
          position: 'absolute',

          '& a.grid-submenu-item': {
            '& input.margin-right-little': {
              zIndex: 1,
            },
          },

          '& .normal-font': {
            fontWeight: 400,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: 164,
            padding: 0,
          },
        },
      },

      '& .grid-submenu-flyout:hover': {
        '& .adgroups-list': {
          display: 'block',
        },
      },
    },
  },

  '.advanced-keyword-planner.bingadsgrid': {
    width: 800,

    '& .grid-header-text': {
      fontWeight: 'normal',
    },

    '& .sort-indicator.glyphicon-arrow-up:before': {
      content: '"\\EE68"',
    },

    '& .sort-indicator.glyphicon-arrow-down:before': {
      content: '"\\EE69"',
    },

    '& .table-container': {
      '& .header': {
        '& th[data-name="name"]': {
          minWidth: 200,
        },
        '& th[data-name="searchCount"]': {
          minWidth: 170,
        },
        '& th[data-name="averageCPC"]': {
          minWidth: 230,
        },
        '& th[data-name="competition"]': {
          minWidth: 140,
        },
        '& .helpbutton:before': {
          position: 'static',
        },
      },

      '& tbody': {
        '& .table__row--keyword-planner': {
          '& .grid-cell-text': {
            wordBreak: 'normal',
          },
        },
      },
    },
  },

});
